import { Col, Form, Row } from 'antd'
import React, { useState } from 'react'
import InnerCardHeader from '../../../../components/atoms/cardHeader/InnerCardHeader'
import CommonFields from './CommonFields'
import BottomComboButtons from '../../../../components/atoms/formFields/buttons/bottomComboButtons'
import { SaveReturnPolicy, UpdateReturnPolicy } from '../../../../store/thunks/vendorStoreThunk'
import { useDispatch, useSelector } from 'react-redux'
import { isNumberOnly } from '../../../../utils/regex'

const ReturnExchange = ({ storeId }) => {
    const { data } = useSelector((state) => state?.returnPolicy);
    const dispatch = useDispatch();
    const [returnData, setReturnData] = useState();
    const [errors, setErrors] = useState();

    return (
        <Form>
            <InnerCardHeader name="Return & Exchange" />
            <div className="p-4">
                <Row gutter={[12, 5]} id="ant_inputs">
                    <CommonFields type="Return" returnData={returnData} setReturnData={setReturnData} errors={errors} setErrors={setErrors} storeId={storeId} />
                    <Col className="gutter-row" xs={24}>
                        <div className="separator separator-solid my-5 d-block"></div>
                    </Col>
                    <CommonFields type="Exchange" returnData={returnData} setReturnData={setReturnData} errors={errors} setErrors={setErrors} storeId={storeId} />
                </Row>
                <BottomComboButtons name1={"Cancel"} name2={"Save"} extraClasses="w-100"
                    onClick2={(e) => {
                        e.preventDefault();
                        if (
                            returnData?.returnEligibleDays &&
                            returnData?.returnEligiblePolicy &&
                            returnData?.exchangeEligibleDays &&
                            returnData?.exchangeEligiblePolicy
                        ) {
                            data?.id ? dispatch(UpdateReturnPolicy({payload: returnData})) : dispatch(SaveReturnPolicy({payload: returnData}))
                            setErrors({});
                        } else {
                            setErrors({
                                ...errors,
                                returnEligibleDays: returnData?.returnEligibleDays
                                    ? (isNumberOnly(returnData?.returnEligibleDays) ? "" : "Invalid Days")
                                    : "Number of Days is Mandatory",
                                exchangeEligibleDays: returnData?.exchangeEligibleDays
                                    ? (isNumberOnly(returnData?.exchangeEligibleDays) ? "" : "Invalid Days")
                                    : "Number of Days is Mandatory",
                                returnEligiblePolicy: returnData?.returnEligiblePolicy
                                    ? ""
                                    : "Refund Policy is Mandatory",
                                exchangeEligiblePolicy: returnData?.exchangeEligiblePolicy
                                    ? ""
                                    : "Exchange Policy is Mandatory",
                            });
                            returnData.exchangeEligiblePolicy
                                ? document
                                    .querySelector(".ReturnRules .tox-tinymce")
                                    .classList.remove("invalid")
                                : document
                                    .querySelector(".ReturnRules .tox-tinymce")
                                    .classList.add("invalid");

                            returnData.returnEligiblePolicy
                                ? document
                                    .querySelector(".ExchangeRules .tox-tinymce")
                                    .classList.remove("invalid")
                                : document
                                    .querySelector(".ExchangeRules .tox-tinymce")
                                    .classList.add("invalid");
                        }
                    }}
                />
            </div>
        </Form>
    )
}

export default ReturnExchange